// Offline invoice drafts — queued in localStorage, auto-synced when online.
import axios from "axios";

const KEY = "offline_invoice_drafts";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const getDrafts = () => {
  try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; }
};

const save = (list) => localStorage.setItem(KEY, JSON.stringify(list));

export const queueDraft = (payload) => {
  const list = getDrafts();
  const draft = {
    draft_id: `${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    queued_at: new Date().toISOString(),
    payload,
  };
  list.push(draft);
  save(list);
  return draft;
};

export const removeDraft = (id) => save(getDrafts().filter((d) => d.draft_id !== id));

let _syncing = false;

export async function syncDrafts() {
  if (_syncing) return { synced: 0, dropped: 0, remaining: getDrafts().length };
  _syncing = true;
  try {
    const drafts = getDrafts();
    let synced = 0, dropped = 0;
    for (const d of drafts) {
      try {
        await axios.post(`${API}/invoices`, d.payload);
        removeDraft(d.draft_id); synced++;
      } catch (e) {
        const st = e?.response?.status;
        if (st === 409) {
          // Duplicate number — retry letting the backend auto-number.
          try {
            const { invoice_no, ...rest } = d.payload;
            await axios.post(`${API}/invoices`, rest);
            removeDraft(d.draft_id); synced++;
          } catch { dropped++; removeDraft(d.draft_id); }
        } else if (st && st >= 400 && st < 500) {
          // Permanently invalid draft — drop so it doesn't retry forever.
          removeDraft(d.draft_id); dropped++;
        }
        // network / 5xx → keep queued for the next sync
      }
    }
    return { synced, dropped, remaining: getDrafts().length };
  } finally {
    _syncing = false;
  }
}
